import '@toasttab/main/src/assets/styles/global.css'
import 'lazysizes'
import React, { Suspense } from 'react'
import RootElement from './src/components/root-element'
import { wrapPageElement as SharedWrapPageElement } from '@toasttab/shared/src/page/wrapPageElement'
import { sha256encode } from '@toasttab/shared/src/utils/dataCaptureUtils'
import _helpers from '@toasttab/shared/src/globals/_helpers'

export const disableCorePrefetching = () => true

export const wrapRootElement = ({ element }: any) => {
  const enableContentfulLivePreview =
    process.env.GATSBY_CONTENTFUL_LIVE_PREVIEW_ENABLE !== 'false'

  // Get locale from query string (only runs in browser)
  let locale = 'en'
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search)
    locale = params.get('locale') || 'en'
  }

  if (enableContentfulLivePreview) {
    // If deployed to a preview site, load the ContentfulLivePreviewProvider bundle
    const ContentfulLivePreviewProvider = React.lazy(() =>
      import(
        /* webpackChunkName: "vendor-contentful-live-preview" */
        '@contentful/live-preview/react'
      ).then((m) => ({
        default: m.ContentfulLivePreviewProvider
      }))
    )
    const App = () => (
      <Suspense fallback={null}>
        <ContentfulLivePreviewProvider
          locale={String(locale)}
          enableInspectorMode={true}
          enableLiveUpdates={true}
          debugMode={false}
        >
          <RootElement>{element}</RootElement>
        </ContentfulLivePreviewProvider>
      </Suspense>
    )
    return <App />
  } else {
    // If not running on a preview site, don't load the ContentfulLivePreviewProvider bundle
    const App = () => <RootElement>{element}</RootElement>
    return <App />
  }
}

export const wrapPageElement = SharedWrapPageElement

export const onClientEntry = () => {
  if (typeof window === 'undefined') return // Ensure this runs only in the browser

  // @ts-ignore
  window.dataLayer = window.dataLayer || []

  const initGTMOnEvent = (event: any) => {
    console.log('initGTMOnEvent')
    initGTM()
    event.currentTarget.removeEventListener(event.type, initGTMOnEvent) // Remove the triggered event listener
  }

  const initGTM = () => {
    // @ts-ignore
    if (window.gtmDidInit) {
      return false // Ensure the script is not added multiple times
    }
    // @ts-ignore
    window.gtmDidInit = true

    // Create and append the GTM script
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-MNHK89W'

    script.onload = () => {
      // @ts-ignore
      window.dataLayer.push({
        event: 'gtm.js',
        'gtm.start': new Date().getTime(),
        'gtm.uniqueEventId': 0
      }) // Ensure PageViews are tracked
    }

    // MKE-3149: Add SHA256 hashed email and phone number to dataLayer for GTM tracking pixel
    if (_helpers.getCookie('email') || _helpers.getCookie('phonenumber')) {
      Promise.all([
        sha256encode(_helpers.getCookie('email')),
        sha256encode(_helpers.getCookie('phonenumber'))
      ]).then(([encodedEmail, encodedPhone]) => {
        // @ts-ignore
        window.dataLayer.push({
          user_data: {
            sha256_email_address: encodedEmail,
            sha256_phone_number: encodedPhone
          }
        })
      })
    }

    document.head.appendChild(script)
  }

  // Add event listeners
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initGTM, 3500) // Initialize GTM after 3500ms
  })

  document.addEventListener('scroll', initGTMOnEvent)
  document.addEventListener('mousemove', initGTMOnEvent)
  document.addEventListener('touchstart', initGTMOnEvent)
}
